var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-comparator", attrs: { id: "productcomparator" } },
    [
      _c("div", { staticClass: "product-comparator__options" }, [
        _c(
          "div",
          { staticClass: "product-comparator__type" },
          [
            _vm.options.length > 1
              ? _c("v-select", {
                  attrs: {
                    label: "label",
                    options: _vm.options,
                    placeholder: _vm.firstPlaceholder
                  },
                  model: {
                    value: _vm.selectedOption,
                    callback: function($$v) {
                      _vm.selectedOption = $$v
                    },
                    expression: "selectedOption"
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        !_vm.hidesecondfilter && _vm.additionalOptions.length > 1
          ? _c(
              "div",
              { staticClass: "product-comparator__results" },
              [
                _c("v-select", {
                  staticClass: "white",
                  attrs: {
                    options: _vm.additionalOptions,
                    placeholder: "Filter by options"
                  },
                  model: {
                    value: _vm.selectedAdditionalOption,
                    callback: function($$v) {
                      _vm.selectedAdditionalOption = $$v
                    },
                    expression: "selectedAdditionalOption"
                  }
                })
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-comparator__items" },
        [
          false &&
          _vm.currentTaxonomy &&
          _vm.currentTaxonomy.acf &&
          _vm.currentTaxonomy.acf.upsell_image
            ? _c(
                "div",
                {
                  staticClass:
                    "product-comparator__item product-comparator__item--upsell",
                  style:
                    "background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(" +
                    _vm.currentTaxonomy.acf.upsell_image.sizes.medium_large +
                    ") no-repeat center center / cover;"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass:
                        "product-comparator__item product-comparator__item--upsell-link",
                      attrs: { href: _vm.currentTaxonomy.acf.upsell_link.url }
                    },
                    [
                      _c("h3", {
                        staticClass: "product-comparator__item--upsell-title",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.currentTaxonomy.acf.upsell_title
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "product-comparator__item--upsell-text"
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.currentTaxonomy.acf.upsell_text) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.allData, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "product-comparator__item" },
              [
                _c("a", { attrs: { href: item.link } }, [
                  item.acf.image.length > 0
                    ? _c("div", {
                        staticClass: "product-comparator__item--image",
                        style:
                          "background:url(" +
                          item.acf.image[0].sizes.medium_large +
                          ") no-repeat center center / contain;"
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("h3", {
                    staticClass: "product-comparator__item--title",
                    domProps: { innerHTML: _vm._s(item.title.rendered) }
                  })
                ]),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      item.acf.excerpt ||
                        _vm.shorten(item.content.rendered, 160)
                    )
                  }
                }),
                _vm._v(" "),
                item.acf.price
                  ? _c(
                      "div",
                      { staticClass: "product-comparator__item--price" },
                      [
                        _vm._v(
                          "\n        £" +
                            _vm._s(item.acf.price) +
                            " p/m\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("p", [
                  _c(
                    "a",
                    {
                      staticClass:
                        "elementor-button-link elementor-button elementor-size-sm button-white product-comparator__item--seemore",
                      attrs: { href: item.link }
                    },
                    [_vm._v("see more")]
                  ),
                  _vm._v(" "),
                  _vm.comparable
                    ? _c(
                        "a",
                        {
                          class:
                            "elementor-button-link \n                 elementor-button \n                 elementor-size-sm \n                 product-comparator__item--comparebutton" +
                            (_vm.isSelected(item)
                              ? " product-comparator__item--active"
                              : ""),
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.select(item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isSelected(item)
                                  ? "remove from comparison"
                                  : "add to comparison"
                              ) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.selectedItems.length > 0
        ? _c("div", { staticClass: "product-comparator__comparisonwrapper" }, [
            _c("table", [
              _c(
                "thead",
                [
                  _c("td"),
                  _vm._l(_vm.selectedItems, function(item, index) {
                    return _c("td", { key: index }, [
                      _c(
                        "h4",
                        { staticClass: "product-comparator__comparisontitle" },
                        [_vm._v(_vm._s(item.title.rendered))]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "product-comparator__comparisonimage",
                        style:
                          "background:url(" +
                          item.acf.main_image.sizes.medium_large +
                          ") no-repeat center center / contain;"
                      })
                    ])
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("tbody", [
                _c(
                  "tr",
                  [
                    _c("td", [_vm._v("Popularity")]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedItems, function(item, index) {
                      return _c("td", { key: index }, [
                        _vm._v(_vm._s(item.acf.popularity))
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  [
                    _c("td", [_vm._v("Range")]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedItems, function(item, index) {
                      return _c("td", { key: index }, [
                        _vm._v(_vm._s(item.acf.range))
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  [
                    _c("td", [_vm._v("Regular or Decaf")]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedItems, function(item, index) {
                      return _c("td", { key: index }, [
                        _vm._v(_vm._s(item.acf.regular_or_decaf))
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  [
                    _c("td", [_vm._v("Roast")]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedItems, function(item, index) {
                      return _c("td", { key: index }, [
                        _vm._v(_vm._s(item.acf.roast))
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  [
                    _c("td", [_vm._v("Certifications")]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedItems, function(item, index) {
                      return _c("td", { key: index }, [
                        _c(
                          "ul",
                          _vm._l(item.acf.certification, function(
                            certif,
                            indexCertif
                          ) {
                            return _c("li", { key: indexCertif }, [
                              _vm._v(_vm._s(certif))
                            ])
                          }),
                          0
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  [
                    _c("td", [_vm._v("Available as")]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedItems, function(item, index) {
                      return _c("td", { key: index }, [
                        _c(
                          "ul",
                          _vm._l(item.acf.availability, function(av, indexAv) {
                            return _c("li", { key: indexAv }, [
                              _vm._v(_vm._s(av))
                            ])
                          }),
                          0
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "tr",
                  [
                    _c("td", [_vm._v("Origin")]),
                    _vm._v(" "),
                    _vm._l(_vm.selectedItems, function(item, index) {
                      return _c("td", { key: index }, [
                        _vm._v(_vm._s(item.acf.origin))
                      ])
                    })
                  ],
                  2
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!C:/MAMP/htdocs/matthew-algie/public_html/app/themes/matthewalgie/node_modules/vue-loader/lib?{"loaders":{"js":{"loader":"babel-loader","options":{"presets":[["@babel/preset-env",{"targets":{"browsers":["> .25%"]},"corejs":"2.0","useBuiltIns":"entry","forceAllTransforms":true,"ignoreBrowserslistConfig":false,"modules":false,"debug":true}]],"plugins":[["@babel/transform-runtime"],["@babel/plugin-transform-object-assign"]]}}}}!./scripts/vue/components/ProductComparator.vue?vue&type=template&id=53d8f4e0&
// module id = 103
// module chunks = 3